import { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  padding: 20px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const Text = styled.h2`
  font-size: 1.5em;
  text-align: center;
  color: rgba(87, 79, 191, 1);
`;

const Answer = styled.div`
  display: flex;
  margin-top: 0.5em;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const AnswerItem = styled.div`
  display: flex;
  border: 2px ${({ selected }) => (selected ? "solid" : "dashed")}
    rgba(87, 79, 191, 1);
  width: 60px;
  height: 60px;
  margin: 10px;
  cursor: pointer;
`;

const Emojis = styled.div`
  display: flex;
  gap: 20px;
  line-height: 60px;
  margin-top: 40px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const Emoji = styled.div`
  display: flex;
  font-size: 45px;
  align-items: center;
  justify-content: center;
  width: 60px;
  cursor: pointer;
`;

function Phrase() {
  const [index, setIndex] = useState(0);
  const [item0, setItem0] = useState("");
  const [item1, setItem1] = useState("");
  const [item2, setItem2] = useState("");

  const loadItem = (emoji) => {
    if (index === 0) {
      setItem0(emoji);
    }
    if (index === 1) {
      setItem1(emoji);
    }
    if (index === 2) {
      setItem2(emoji);
    }
  };

  const isCorrect = item0 === "🙋🏼" && item1 === "💗" && item2 === "👨🏼";

  return (
    <Wrapper>
      <Text>"Yo amo a mi papá"</Text>
      <Answer>
        <AnswerItem selected={index === 0} onClick={() => setIndex(0)}>
          <Emoji>{item0}</Emoji>
        </AnswerItem>
        <AnswerItem selected={index === 1} onClick={() => setIndex(1)}>
          <Emoji>{item1}</Emoji>
        </AnswerItem>
        <AnswerItem selected={index === 2} onClick={() => setIndex(2)}>
          <Emoji>{item2}</Emoji>
        </AnswerItem>
        {isCorrect && <Emoji>👍</Emoji>}
      </Answer>
      <Emojis>
        <Emoji onClick={() => loadItem("💃🏾")}>💃🏾</Emoji>
        <Emoji onClick={() => loadItem("🐵")}>🐵</Emoji>
        <Emoji onClick={() => loadItem("💗")}>💗</Emoji>
        <Emoji onClick={() => loadItem("🥕")}>🥕</Emoji>
        <Emoji onClick={() => loadItem("😽")}>😽</Emoji>
        <Emoji onClick={() => loadItem("👰")}>👰</Emoji>
        <Emoji onClick={() => loadItem("🚔")}>🚔</Emoji>
        <Emoji onClick={() => loadItem("🙋🏼")}>🙋🏼</Emoji>
        <Emoji onClick={() => loadItem("🤡")}>🤡</Emoji>
        <Emoji onClick={() => loadItem("🌴")}>🌴</Emoji>
        <Emoji onClick={() => loadItem("👨🏼")}>👨🏼</Emoji>
        <Emoji onClick={() => loadItem("🏠")}>🏠</Emoji>
        <Emoji onClick={() => loadItem("🍆")}>🍆</Emoji>
      </Emojis>
    </Wrapper>
  );
}

export default Phrase;
